import { FaSyncAlt } from "react-icons/fa";
import { Table } from "./Table";
import { useSelector } from "react-redux";
import Filters from "./Filters";

const MyVenues = () => {
  const { venues, loading, error } = useSelector((state) => state.organizer);
  const { filter_data } = useSelector((state) => state.organizerFilters);

  return (
    <>
      <div className="box shadow-none bg-gray mb-4 organizer-event MyScanners">
        <Filters venues={venues} />
      </div>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center">
          <FaSyncAlt className="spinIcon" />
        </div>
      ) : (
        <Table data={filter_data.venues} error={error} />
      )}
    </>
  );
};

export default MyVenues;
